import { render, staticRenderFns } from "./EstadisticasCompras.vue?vue&type=template&id=21d41fac&scoped=true&lang=pug"
import script from "./EstadisticasCompras.vue?vue&type=script&lang=js"
export * from "./EstadisticasCompras.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCompras.vue?vue&type=style&index=0&id=21d41fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d41fac",
  null
  
)

export default component.exports